/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import { print } from "graphql";
import gql from "graphql-tag";
export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["Public"] = "PUBLIC";
    CacheControlScope["Private"] = "PRIVATE";
})(CacheControlScope || (CacheControlScope = {}));
export var MicroGeneralStatus;
(function (MicroGeneralStatus) {
    MicroGeneralStatus["Active"] = "active";
    MicroGeneralStatus["Inactive"] = "inactive";
})(MicroGeneralStatus || (MicroGeneralStatus = {}));
export var PwsCoastFeaturedItemContentType;
(function (PwsCoastFeaturedItemContentType) {
    PwsCoastFeaturedItemContentType["Show"] = "SHOW";
    PwsCoastFeaturedItemContentType["Article"] = "ARTICLE";
    PwsCoastFeaturedItemContentType["Photo"] = "PHOTO";
})(PwsCoastFeaturedItemContentType || (PwsCoastFeaturedItemContentType = {}));
export var PwsCoastFeaturedPlatform;
(function (PwsCoastFeaturedPlatform) {
    PwsCoastFeaturedPlatform["Desktop"] = "DESKTOP";
})(PwsCoastFeaturedPlatform || (PwsCoastFeaturedPlatform = {}));
export var PwsCoastSearchPlatform;
(function (PwsCoastSearchPlatform) {
    PwsCoastSearchPlatform["Desktop"] = "DESKTOP";
    PwsCoastSearchPlatform["App"] = "APP";
})(PwsCoastSearchPlatform || (PwsCoastSearchPlatform = {}));
/** The type of the database field. */
export var PlaylistsFieldType;
(function (PlaylistsFieldType) {
    /** Textual data. */
    PlaylistsFieldType["Text"] = "TEXT";
    /** Numerical data. */
    PlaylistsFieldType["Number"] = "NUMBER";
    /** A date, represented as a number. */
    PlaylistsFieldType["Date"] = "DATE";
    /** Boolean data. */
    PlaylistsFieldType["Boolean"] = "BOOLEAN";
})(PlaylistsFieldType || (PlaylistsFieldType = {}));
/** The type of match to make. */
export var PlaylistsMatchType;
(function (PlaylistsMatchType) {
    /** An exact value match. */
    PlaylistsMatchType["Match"] = "MATCH";
    /** Match the beginning of the text. */
    PlaylistsMatchType["Prefix"] = "PREFIX";
    /** Match the end of the text. */
    PlaylistsMatchType["Suffix"] = "SUFFIX";
    /** Match if anywhere within the text (can be slow). */
    PlaylistsMatchType["Contain"] = "CONTAIN";
    /** A fuzzy match (may contain mispellings, etc). */
    PlaylistsMatchType["Fuzzy"] = "FUZZY";
    /** Is not an exact match. */
    PlaylistsMatchType["Not"] = "NOT";
    /** Value is less than the search (only works for numeric values). */
    PlaylistsMatchType["LessThan"] = "LESS_THAN";
    /** Value is greater than the search (only works for numeric values). */
    PlaylistsMatchType["GreaterThan"] = "GREATER_THAN";
})(PlaylistsMatchType || (PlaylistsMatchType = {}));
export var PlaylistsPlaylistType;
(function (PlaylistsPlaylistType) {
    /** An automatically generated playlist that is mapped to a live station. */
    PlaylistsPlaylistType["Dynamic"] = "DYNAMIC";
    /** A hand-curated playlist. Created and managed exclusively by a user of the Playlists tool. */
    PlaylistsPlaylistType["Manual"] = "MANUAL";
})(PlaylistsPlaylistType || (PlaylistsPlaylistType = {}));
/** The order of sort. */
export var PlaylistsSortType;
(function (PlaylistsSortType) {
    /** Sort results in ascending order. */
    PlaylistsSortType["Asc"] = "ASC";
    /** Sort results in descending order. */
    PlaylistsSortType["Desc"] = "DESC";
})(PlaylistsSortType || (PlaylistsSortType = {}));
/** How to combine tags in distribution (i.e. "match all tags" vs "match any combination of tags" */
export var PubsubDistributionOperator;
(function (PubsubDistributionOperator) {
    PubsubDistributionOperator["And"] = "AND";
})(PubsubDistributionOperator || (PubsubDistributionOperator = {}));
export var PubsubDsSubscriptionBackfillStates;
(function (PubsubDsSubscriptionBackfillStates) {
    /** Materialization hasn't occurred, or the datasource was updated */
    PubsubDsSubscriptionBackfillStates["Unknown"] = "UNKNOWN";
    /** Materialization has been queued */
    PubsubDsSubscriptionBackfillStates["Starting"] = "STARTING";
    /** Materialization is active (check processed/total counts for progress) */
    PubsubDsSubscriptionBackfillStates["InProgress"] = "IN_PROGRESS";
    /** Materialization is finished */
    PubsubDsSubscriptionBackfillStates["Complete"] = "COMPLETE";
    /** The first batch of content has been materialized, and the remainder is queued */
    PubsubDsSubscriptionBackfillStates["InitialComplete"] = "INITIAL_COMPLETE";
})(PubsubDsSubscriptionBackfillStates || (PubsubDsSubscriptionBackfillStates = {}));
export var PubsubSortField;
(function (PubsubSortField) {
    PubsubSortField["PubStart"] = "PUB_START";
    PubsubSortField["PubTouched"] = "PUB_TOUCHED";
    PubsubSortField["None"] = "NONE";
})(PubsubSortField || (PubsubSortField = {}));
export var Sites_Lookup_By;
(function (Sites_Lookup_By) {
    Sites_Lookup_By["Id"] = "ID";
    Sites_Lookup_By["Slug"] = "SLUG";
    Sites_Lookup_By["Brand"] = "BRAND";
    Sites_Lookup_By["Hostname"] = "HOSTNAME";
    Sites_Lookup_By["Show"] = "SHOW";
    Sites_Lookup_By["PrimaryParentOf"] = "PRIMARY_PARENT_OF";
    Sites_Lookup_By["BroadcastFacility"] = "BROADCAST_FACILITY";
    Sites_Lookup_By["BroadcastFacilityCallsign"] = "BROADCAST_FACILITY_CALLSIGN";
    Sites_Lookup_By["Stream"] = "STREAM";
    Sites_Lookup_By["Genre"] = "GENRE";
    Sites_Lookup_By["Podcast"] = "PODCAST";
})(Sites_Lookup_By || (Sites_Lookup_By = {}));
export var Sites_Onair_Day;
(function (Sites_Onair_Day) {
    Sites_Onair_Day["Su"] = "SU";
    Sites_Onair_Day["Mo"] = "MO";
    Sites_Onair_Day["Tu"] = "TU";
    Sites_Onair_Day["We"] = "WE";
    Sites_Onair_Day["Th"] = "TH";
    Sites_Onair_Day["Fr"] = "FR";
    Sites_Onair_Day["Sa"] = "SA";
})(Sites_Onair_Day || (Sites_Onair_Day = {}));
export var Sites_Onair_Source;
(function (Sites_Onair_Source) {
    Sites_Onair_Source["Core"] = "CORE";
    Sites_Onair_Source["User"] = "USER";
})(Sites_Onair_Source || (Sites_Onair_Source = {}));
export var Sites_Referenced_By;
(function (Sites_Referenced_By) {
    Sites_Referenced_By["EmbeddedIn"] = "EMBEDDED_IN";
})(Sites_Referenced_By || (Sites_Referenced_By = {}));
export var SitesDestinationType;
(function (SitesDestinationType) {
    SitesDestinationType["Url"] = "URL";
    SitesDestinationType["Brand"] = "BRAND";
})(SitesDestinationType || (SitesDestinationType = {}));
export var SitesLinksType;
(function (SitesLinksType) {
    SitesLinksType["LinksIn"] = "LINKS_IN";
    SitesLinksType["LinksOut"] = "LINKS_OUT";
})(SitesLinksType || (SitesLinksType = {}));
export var SitesQueryDatasource;
(function (SitesQueryDatasource) {
    SitesQueryDatasource["Publishing"] = "PUBLISHING";
    SitesQueryDatasource["Leads"] = "LEADS";
    SitesQueryDatasource["Pws"] = "PWS";
    SitesQueryDatasource["Audience"] = "AUDIENCE";
})(SitesQueryDatasource || (SitesQueryDatasource = {}));
export var SitesRedirectQueryParamsHandling;
(function (SitesRedirectQueryParamsHandling) {
    SitesRedirectQueryParamsHandling["Original"] = "ORIGINAL";
    SitesRedirectQueryParamsHandling["Merge"] = "MERGE";
    SitesRedirectQueryParamsHandling["Discard"] = "DISCARD";
})(SitesRedirectQueryParamsHandling || (SitesRedirectQueryParamsHandling = {}));
export var SitesSortField;
(function (SitesSortField) {
    SitesSortField["PubStart"] = "PUB_START";
    SitesSortField["PubTouched"] = "PUB_TOUCHED";
    SitesSortField["None"] = "NONE";
})(SitesSortField || (SitesSortField = {}));
export var SitesTaskStatus;
(function (SitesTaskStatus) {
    SitesTaskStatus["Idle"] = "IDLE";
    SitesTaskStatus["Pending"] = "PENDING";
    SitesTaskStatus["Error"] = "ERROR";
})(SitesTaskStatus || (SitesTaskStatus = {}));
export var SitesVariableSource;
(function (SitesVariableSource) {
    SitesVariableSource["Config"] = "CONFIG";
    SitesVariableSource["Page"] = "PAGE";
})(SitesVariableSource || (SitesVariableSource = {}));
export var SitesYoutubeBlockLinkType;
(function (SitesYoutubeBlockLinkType) {
    SitesYoutubeBlockLinkType["Channel"] = "CHANNEL";
    SitesYoutubeBlockLinkType["Playlist"] = "PLAYLIST";
})(SitesYoutubeBlockLinkType || (SitesYoutubeBlockLinkType = {}));
export var TalkBackSource;
(function (TalkBackSource) {
    TalkBackSource["Live"] = "LIVE";
    TalkBackSource["Podcast"] = "PODCAST";
})(TalkBackSource || (TalkBackSource = {}));
/** The current status of an audio transcode process for a TalkBack. */
export var TalkBackTranscodeStatus;
(function (TalkBackTranscodeStatus) {
    TalkBackTranscodeStatus["InputInformation"] = "INPUT_INFORMATION";
    TalkBackTranscodeStatus["Progressing"] = "PROGRESSING";
    TalkBackTranscodeStatus["Complete"] = "COMPLETE";
    TalkBackTranscodeStatus["Error"] = "ERROR";
})(TalkBackTranscodeStatus || (TalkBackTranscodeStatus = {}));
const result = {
    possibleTypes: {
        BaseConfig: ["MicroConfig", "SiteConfig"],
        BaseIndex: ["MicroIndex", "SiteIndex"],
        ChartsPagedResult: ["ChartsChartsResults", "ChartsListResults", "ChartsPagedResults"],
        ConfigData: ["MicroData", "SiteData"],
        PWSCoastFeaturedResult: ["PWSCoastFeaturedDefaultPlatform", "PWSCoastFeaturedDesktopPlatform"],
        PWSCoastSearchResponseValue: ["PWSCoastSearchResponseByCategoryValue", "PWSCoastSearchResponseMergedValue"],
        PWSPagedResult: ["PWSCoastSearchResponse", "PWSPagedResults"],
        SitesConfigTemplateUnion: [
            "SitesTemplateCoastConfig",
            "SitesTemplateInfernoMicrosite",
            "SitesTemplateInfernoSite",
            "SitesTemplateOnairEnrichment",
            "SitesTemplatePremiereSite",
        ],
        SitesFeedResult: ["SitesFeedAudienceResult", "SitesFeedLeadsResult", "SitesFeedPWSResult", "SitesFeedPubsubResult"],
        SitesIntegrationPlugin: [
            "SitesAppleNewsIntegration",
            "SitesBroadcastFacilitiesIntegration",
            "SitesFBIAIntegration",
            "SitesShowsKeysIntegration",
            "SitesSlackIntegration",
            "SitesStreamKeysIntegration",
            "SitesYoutubeIntegration",
        ],
        SitesPWSRecord: ["SitesPWSGuest"],
        SitesPageBlock: [
            "SitesBlock",
            "SitesFeedBlock",
            "SitesItemBlock",
            "SitesKeywordContestBlock",
            "SitesPodcastsBlock",
            "SitesShowBlock",
            "SitesYoutubeBlock",
        ],
        SitesPagedResult: [
            "SitesAdPositionResults",
            "SitesConfigInternalResults",
            "SitesConfigOverrideResults",
            "SitesIndexInternalResults",
            "SitesIndexResults",
            "SitesOnAirResults",
            "SitesPageOverrideResults",
            "SitesPagedResults",
        ],
        TrackHistory: ["CombinedPnpTrackHistory", "PnpTrackHistory"],
    },
};
export default result;
export const PodcastEpisodeFragmentDoc = gql `
  fragment PodcastEpisode on PodcastEpisode {
    id
    podcastId
    podcastSlug
    title
    duration
    isExplicit
    description
    startDate
    imageUrl
  }
`;
export const PodcastEpisodesFragmentDoc = gql `
  fragment PodcastEpisodes on PodcastEpisodes {
    pageInfo {
      nextCursor
    }
    items {
      ...PodcastEpisode
    }
  }
  ${PodcastEpisodeFragmentDoc}
`;
export const PodcastFragmentDoc = gql `
  fragment Podcast on Podcast {
    id
    title
    description
    lastUpdated
    slug
    isExternal
    imageUrl
    episodes(paging: $paging) {
      ...PodcastEpisodes
    }
  }
  ${PodcastEpisodesFragmentDoc}
`;
export const ArtistDetailFragmentDoc = gql `
  fragment ArtistDetail on Artist {
    artistName
    genreId
  }
`;
export const TrackDetailFragmentDoc = gql `
  fragment TrackDetail on PnpTrack {
    artistId
    albumId
    trackId
    title
    artist {
      ...ArtistDetail
    }
    albumName
    trackDuration
    imagePath
    explicitLyrics
    lyricsId
    playbackRights {
      onDemand
    }
  }
  ${ArtistDetailFragmentDoc}
`;
export const TopTrackDetailFragmentDoc = gql `
  fragment TopTrackDetail on TopTrack {
    trackId
    count
    rank
    track {
      ...TrackDetail
    }
  }
  ${TrackDetailFragmentDoc}
`;
export const TopTracksFragmentDoc = gql `
  fragment TopTracks on LiveMetaTopTracks {
    count
    pageInfo {
      nextCursor
    }
    tracks {
      ...TopTrackDetail
    }
  }
  ${TopTrackDetailFragmentDoc}
`;
export const CurrentlyPlayingTrackDetailFragmentDoc = gql `
  fragment CurrentlyPlayingTrackDetail on CombinedPnpTrackHistory {
    artistId
    albumId
    trackId
    title
    artist {
      ...ArtistDetail
    }
    albumName
    trackDuration
    imagePath
    explicitLyrics
    lyricsId
    playbackRights {
      onDemand
    }
    startTime
    endTime
    status
    offset
    trackDurationInSec
    dataSource
    isCurrentlyPlayingTrack
  }
  ${ArtistDetailFragmentDoc}
`;
export const CurrentlyPlayingFragmentDoc = gql `
  fragment CurrentlyPlaying on LiveMetaCurrentlyPlaying {
    count
    pageInfo {
      nextCursor
    }
    tracks {
      ...CurrentlyPlayingTrackDetail
    }
  }
  ${CurrentlyPlayingTrackDetailFragmentDoc}
`;
export const AptivadaAppFragmentDoc = gql `
  fragment AptivadaApp on AptivadaApp {
    appType
    appId
    parentAppId
    title
    shareTitle
    tags
    gridStatus
    gridRedirect
    pageUrl
    primaryImage
    mobileImage
    gridImage
    prize
    sort
    startTime
    endTime
    scheduleStatus
    startDate
    endDate
    description
    active
    subtitle
    type
    displayImage
    accountId
    facebookShareImage
    width
    shareLocation
    timeZone
  }
`;
export const KeywordDetailsFragmentDoc = gql `
  fragment KeywordDetails on KeywordDetails {
    sort
    timeStamp
    endTime
    isComplete
    isLive
    isStarted
    isSubmittable
    active
    title
    countdownKeywordId
    prize
  }
`;
export const AptivadaKeywordAppFragmentDoc = gql `
  fragment AptivadaKeywordApp on AptivadaKeywordApp {
    appType
    appId
    title
    currentKeyword {
      previous {
        ...KeywordDetails
      }
      current {
        ...KeywordDetails
      }
      next {
        ...KeywordDetails
      }
    }
    submittableKeyword {
      previous {
        ...KeywordDetails
      }
      current {
        ...KeywordDetails
      }
      next {
        ...KeywordDetails
      }
    }
  }
  ${KeywordDetailsFragmentDoc}
`;
export const CalendarEventFragmentDoc = gql `
  fragment CalendarEvent on CalendarEvent {
    id
    eventId
    origins
    startDateTime
    endDateTime
    tags
    origins
    venueName
    venueAddress
    content {
      id
      img
      title
      slug
      summary
      author
      publish_date
      publish_origin
      record {
        payload {
          blocks
          canonical_url
        }
        eyebrow {
          topic
          topic_name
        }
        subscription {
          tags
        }
      }
    }
  }
`;
export const ChartYearMonthFragmentDoc = gql `
  fragment ChartYearMonth on ChartsChartYearMonth {
    year
    months
  }
`;
export const ChartDatesListFragmentDoc = gql `
  fragment ChartDatesList on ChartsChartDatesList {
    months {
      ...ChartYearMonth
    }
  }
  ${ChartYearMonthFragmentDoc}
`;
export const ChartDatesFunctionFragmentDoc = gql `
  fragment ChartDatesFunction on ChartsChart {
    dates {
      ...ChartDatesList
    }
  }
  ${ChartDatesListFragmentDoc}
`;
export const ChartListPartialFragmentDoc = gql `
  fragment ChartListPartial on ChartsList {
    topItems
    slug
    title
    image
  }
`;
export const ChartListPartialResultsFragmentDoc = gql `
  fragment ChartListPartialResults on ChartsListResults {
    items {
      ...ChartListPartial
    }
    pageInfo {
      nextCursor
    }
  }
  ${ChartListPartialFragmentDoc}
`;
export const ChartListsPartialsFunctionFragmentDoc = gql `
  fragment ChartListsPartialsFunction on ChartsChart {
    lists(filters: { size: $listsSize, cursor: $listsCursor, startDate: $listsStartDate, endDate: $listsEndDate }) {
      ...ChartListPartialResults
    }
  }
  ${ChartListPartialResultsFragmentDoc}
`;
export const ChartV2FragmentDoc = gql `
  fragment ChartV2 on ChartsChart {
    slug
    id
    title
    subtitle
    ...ChartDatesFunction @include(if: $includeDates)
    ...ChartListsPartialsFunction @include(if: $includeLists)
  }
  ${ChartDatesFunctionFragmentDoc}
  ${ChartListsPartialsFunctionFragmentDoc}
`;
export const ChartListSongFragmentDoc = gql `
  fragment ChartListSong on ChartsChartListSong {
    artist
    delta
    image
    peak
    pos
    timeOnChart
    title
    url
  }
`;
export const ChartsListFragmentDoc = gql `
  fragment ChartsList on ChartsList {
    topItems
    slug
    image
    title
    songs {
      ...ChartListSong
    }
  }
  ${ChartListSongFragmentDoc}
`;
export const CategoryTagFragmentDoc = gql `
  fragment CategoryTag on TagRef {
    id
    taxo {
      memberName
      displayName
    }
  }
`;
export const InfernoSiteAlertFragmentDoc = gql `
  fragment InfernoSiteAlert on SitesTemplateInfernoSiteAlert {
    title
    link
    target
    start_date {
      timestampMs
    }
    end_date {
      timestampMs
    }
  }
`;
export const SocialFragmentDoc = gql `
  fragment Social on SitesTemplateInfernoSiteSocial {
    facebook_switch
    facebook_name
    facebook_app_id
    facebook_fan_page_id
    facebook_page_token
    twitter_switch
    twitter_name
    youtube_switch
    youtube_name
    instagram_switch
    instagram_name
    snapchat_switch
    snapchat_name
    pinterest_switch
    pinterest_name
    tiktok_switch
    tiktok_name
  }
`;
export const ContactFragmentDoc = gql `
  fragment Contact on SitesTemplateInfernoSiteContact {
    page_intro
    show_social_switch
    phone_text_numbers_switch
    request_phone_number
    business_phone_number
    traffic_tip_phone
    newsroom_phone
    sms_number
    prize_pickup_directions_switch
    prize_pickup_info
    location_address1
    location_address2
    location_city
    location_state
    location_zip
    office_hours
    email_form_switch
    employment_info_switch
    contacts {
      type
    }
    eeo_report_asset {
      id
    }
    employment_link_override
    public_file_assistance_link_override
    email_ip_blacklist
    enable_contest_promotions
  }
`;
export const UserConfigFragmentDoc = gql `
  fragment UserConfig on SitesTemplateInfernoSite {
    general {
      name
      positioner
      description
      keywords {
        id
      }
      default_content {
        id
      }
      additional_distributions {
        id
      }
      default_podcasts {
        id
      }
      default_shows {
        id
        sites {
          _id
          slug
          ownBrand
          configByLookup(lookup: $lookup) {
            common {
              branding {
                name
              }
            }
          }
        }
      }
      default_playlists {
        id
      }
      default_event_categories {
        ...CategoryTag
      }
      weather_market
      country {
        id
      }
      geo_latitude
      geo_longitude
      locale {
        taxo {
          name
        }
      }
      additional_copyright
    }
    alert {
      ...InfernoSiteAlert
    }
    navigation {
      contact_menu_switch
      listen_live_switch
      contest_nav_switch
      search_switch
      user_menu_switch
      show_public_file_switch
      advertise_switch
      national_promotions {
        id
        type
        label
        target
        ref
      }
      menu {
        id
        type
        label
        target
        ref
        children {
          id
          type
          label
          target
          ref
        }
      }
      menu_footer {
        id
        type
        label
        target
        ref
        children {
          id
          type
          label
          target
          ref
        }
      }
    }
    design {
      theme
      color_scheme {
        id
      }
      logo_best_res {
        id
        asset {
          bucket
          resourceId
          href
        }
      }
      station_logo {
        id
        asset {
          bucket
          resourceId
          href
        }
      }
      logo_favicon {
        id
        asset {
          bucket
          resourceId
          href
        }
      }
      font {
        id
      }
      accent_color
      header_color
      navigation_color
      navigation_links_color
      ihr_embed_player_bar_stream_override {
        id
        kind
      }
      ihr_embed_player_bar_switch
      ihr_embed_player_bar_stream_theme
      logo_footer {
        id
        asset {
          bucket
          resourceId
          href
        }
      }
      thumbnail_image {
        id
        asset {
          bucket
          resourceId
          href
        }
      }
    }
    social {
      ...Social
    }
    contact {
      ...Contact
    }
    partners {
      iheartradio_switch
      ihr_show_in_iheart_switch
      postup_switch
      email_format {
        id
      }
      outbrain_switch
      traffic_market
      aptivada_switch
      aptivada_id
      google_webmaster_verification
      auth_type {
        taxo {
          name
        }
      }
    }
    ads {
      dfp_switch
      header_bidding
      facebook_ad_track_pixel_switch
      facebook_ad_track_pixel_id
    }
    analytics {
      adobe_library
      parsely_switch
      parsely_account_id
    }
  }
  ${CategoryTagFragmentDoc}
  ${InfernoSiteAlertFragmentDoc}
  ${SocialFragmentDoc}
  ${ContactFragmentDoc}
`;
export const ApplicationNoticesFragmentDoc = gql `
  fragment ApplicationNotices on SitesBroadcastFacilityApplicationNotice {
    text
    link
  }
`;
export const BroadcastFacilitiesFragmentDoc = gql `
  fragment BroadcastFacilities on SitesBroadcastFacility {
    facilityId
    broadcastFrequency
    broadcastBand
    broadcastCallLetters
    applicationNotices {
      ...ApplicationNotices
    }
    politicalLinkOverride
  }
  ${ApplicationNoticesFragmentDoc}
`;
export const BroadcastFacilitiesIntegrationFragmentDoc = gql `
  fragment BroadcastFacilitiesIntegration on SitesBroadcastFacilitiesIntegration {
    type
    plugin {
      broadcastFacilities {
        ...BroadcastFacilities
      }
    }
  }
  ${BroadcastFacilitiesFragmentDoc}
`;
export const SiteConfigFragmentDoc = gql `
  fragment SiteConfig on SitesIndexRecord {
    _id
    canonicalHostname
    hostnames
    facets
    slug
    market
    ownBrand
    timeZone
    keys
    stream {
      id
      primaryPronouncement
      recentlyPlayedEnabled
    }
    ownership {
      id
      taxo {
        source {
          display_name
        }
      }
    }
    summary {
      name
      description
    }
    status {
      hide {
        startDate
        endDate
        redirectTo
      }
      isHidden
      isActive
    }
    configByLookup(lookup: $lookup) {
      _id
      adPositions {
        breakpoints {
          breakpoint
          sizes {
            w
            h
          }
        }
        _id
        positionId
        template
        adSplit
        forceLoad
      }
      routes {
        name
        path
      }
      redirects {
        id
        priority
        source
        regex
        schedule {
          begin
          end
        }
        destination {
          type
          value
        }
        disabled
        permanent
        matchQueryString
        queryParamsHandling
      }
      searchOverrides {
        id
        keywords
        destination {
          type
          value
        }
        disabled
        schedule {
          begin
          end
        }
      }
      sections {
        ...UserConfig
      }
    }
    integration(type: "broadcast-facilities") {
      ...BroadcastFacilitiesIntegration
    }
  }
  ${UserConfigFragmentDoc}
  ${BroadcastFacilitiesIntegrationFragmentDoc}
`;
export const SiteChildRefFragmentDoc = gql `
  fragment SiteChildRef on SitesIndexRecord {
    _id
    slug
    ownBrand
    summary {
      name
      image
    }
    status {
      isActive
    }
  }
`;
export const MicrositeSocialConfigFragmentDoc = gql `
  fragment MicrositeSocialConfig on SitesTemplateInfernoMicrositeSocial {
    facebook_switch
    facebook_name
    twitter_switch
    twitter_name
    youtube_switch
    youtube_name
    instagram_switch
    instagram_name
    snapchat_switch
    snapchat_name
    pinterest_switch
    pinterest_name
    tiktok_switch
    tiktok_name
  }
`;
export const MicrositeGeneralConfigFragmentDoc = gql `
  fragment MicrositeGeneralConfig on SitesTemplateInfernoMicrositeGeneral {
    name
    description
    keywords {
      id
    }
    default_content {
      id
      taxo {
        memberName
        name
        ns
        source {
          display_name
          description
          type
        }
        displayName
      }
    }
    additional_distributions {
      id
    }
    default_podcasts {
      id
    }
    default_playlists {
      id
    }
    thumbnail_image {
      id
      asset {
        bucket
        resourceId
        href
      }
    }
    sixteen_by_nine {
      id
      asset {
        bucket
        resourceId
        href
      }
    }
    recommendations
    status
    active_start {
      timestampMs
      timestamp
    }
    active_end {
      timestampMs
      timestamp
    }
    password_switch
    password
    header_description
  }
`;
export const NavigationMicrositeFragmentDoc = gql `
  fragment NavigationMicrosite on SitesIndexRecord {
    _id
    slug
    ownBrand
    configByLookup(lookup: $lookup) {
      common {
        branding {
          name
        }
      }
    }
  }
`;
export const OnAirShowFragmentDoc = gql `
  fragment OnAirShow on SitesOnAirExtended {
    siteId
    site
    coreShowId
    coreStationId
    name
    show
    station
    link
    onNow
    startTime12
    startDate
    startMs
    startEng
    stopTime12
    stopDate
    stopMs
    stopEng
    showSite {
      slug
      configByLookup(lookup: "site-config-lookups/inferno") {
        sections {
          ... on SitesTemplateInfernoMicrosite {
            general {
              name
              thumbnail_image {
                asset {
                  href
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const OnAirScheduleFragmentDoc = gql `
  fragment OnAirSchedule on SitesOnAirScheduleResponse {
    current {
      ...OnAirShow
    }
    upcoming {
      ...OnAirShow
    }
  }
  ${OnAirShowFragmentDoc}
`;
export const LinkedItemRecordFragmentDoc = gql `
  fragment LinkedItemRecord on SitesPublishRecord {
    ref_id
    slug
    payload
    pub_start
    type
    summary {
      title
      description
    }
  }
`;
export const LinkedItemFragmentDoc = gql `
  fragment LinkedItem on SitesLinksData {
    name
    result {
      items {
        ...LinkedItemRecord
      }
    }
  }
  ${LinkedItemRecordFragmentDoc}
`;
export const PublishRecordFragmentDoc = gql `
  fragment PublishRecord on SitesPublishRecord {
    ref_id
    type
    payload
    slug
    summary {
      image
      title
      description
      author
    }
    pub_start
    pub_until
    pub_changed
    subscription {
      tags
    }
    exclusion {
      tags
    }
    linksData {
      ...LinkedItem
    }
  }
  ${LinkedItemFragmentDoc}
`;
export const LeadsCardFragmentDoc = gql `
  fragment LeadsCard on SitesLeadsCard {
    title
    subtitle
    image: img_uri
    img_meta {
      base_id
      bucket
    }
    link {
      target
      urls
      name
    }
    use_catalog_image
    catalog {
      name
      id
      kind
      country
    }
  }
`;
export const PwsGuestRecordFragmentDoc = gql `
  fragment PWSGuestRecord on SitesPWSGuest {
    id
    slug
    summary {
      title
      description
      image
    }
  }
`;
export const AudienceRecordFragmentDoc = gql `
  fragment AudienceRecord on SitesAudienceApp {
    account
    app_id
    display_image
    end_time
    grid_image
    grid_redirect
    grid_status
    mobile_image
    page_url
    parent_app_id
    primary_image
    prize
    schedule_status
    share_title
    sort
    start_time
    subtitle
    tags
    terms
    title
    type
  }
`;
export const FeedResultFragmentDoc = gql `
  fragment FeedResult on SitesFeedResult {
    id
    type
    ... on SitesFeedPubsubResult {
      record {
        ...PublishRecord
      }
    }
    ... on SitesFeedLeadsResult {
      record {
        ...LeadsCard
      }
    }
    ... on SitesFeedPWSResult {
      record {
        ... on SitesPWSGuest {
          ...PWSGuestRecord
        }
      }
    }
    ... on SitesFeedAudienceResult {
      record {
        ...AudienceRecord
      }
    }
  }
  ${PublishRecordFragmentDoc}
  ${LeadsCardFragmentDoc}
  ${PwsGuestRecordFragmentDoc}
  ${AudienceRecordFragmentDoc}
`;
export const FeedResponseFragmentDoc = gql `
  fragment FeedResponse on SitesFeedResponse {
    results {
      ...FeedResult
    }
    resume {
      id
      context
      size
      from
      scopes
    }
  }
  ${FeedResultFragmentDoc}
`;
export const FeedFragmentDoc = gql `
  fragment Feed on SitesFeedBlock {
    feed(context: $context, scopes: $scopes, from: $from) {
      ...FeedResponse
    }
  }
  ${FeedResponseFragmentDoc}
`;
export const ItemFragmentDoc = gql `
  fragment Item on SitesItemBlock {
    item(context: $context) {
      result {
        ...FeedResult
      }
    }
  }
  ${FeedResultFragmentDoc}
`;
export const PodcastsFragmentDoc = gql `
  fragment Podcasts on SitesPodcastsBlock {
    podcasts
  }
`;
export const ShowSiteFragmentDoc = gql `
  fragment ShowSite on SitesIndexRecord {
    _id
    slug
    ownBrand
    configByLookup(lookup: $lookup) {
      common {
        branding {
          name
          logo {
            asset {
              href
            }
          }
        }
      }
    }
  }
`;
export const ShowsFragmentDoc = gql `
  fragment Shows on SitesShowBlock {
    shows {
      ...ShowSite
    }
  }
  ${ShowSiteFragmentDoc}
`;
export const KeywordContestFragmentDoc = gql `
  fragment KeywordContest on SitesKeywordContestBlock {
    id
    type
    ordinal
    region
    value
    disabled
    tags
    campaignId
  }
`;
export const ThumbnailFragmentDoc = gql `
  fragment Thumbnail on YoutubeThumbnail {
    url
    width
    height
  }
`;
export const ThumbnailMapFragmentDoc = gql `
  fragment ThumbnailMap on YoutubeThumbnailMap {
    default {
      ...Thumbnail
    }
    medium {
      ...Thumbnail
    }
    high {
      ...Thumbnail
    }
    standard {
      ...Thumbnail
    }
    maxres {
      ...Thumbnail
    }
  }
  ${ThumbnailFragmentDoc}
`;
export const PlaylistSnippetFragmentDoc = gql `
  fragment PlaylistSnippet on YoutubePlaylistSnippet {
    title
    description
    thumbnails {
      ...ThumbnailMap
    }
    channelId {
      id
    }
    publishedAt {
      timestampMs
      timestamp
      iso8601
    }
  }
  ${ThumbnailMapFragmentDoc}
`;
export const PageInfoFragmentDoc = gql `
  fragment PageInfo on PageInfo {
    prevToken
    nextToken
    itemTokens
  }
`;
export const PlaylistItemSnippetFragmentDoc = gql `
  fragment PlaylistItemSnippet on YoutubePlaylistItemSnippet {
    title
    description
    thumbnails {
      ...ThumbnailMap
    }
    channelId {
      id
    }
    publishedAt {
      timestampMs
      timestamp
      iso8601
    }
    videoId {
      id
    }
    playlistId {
      id
    }
    position
    channelTitle
  }
  ${ThumbnailMapFragmentDoc}
`;
export const PlaylistItemResultsFragmentDoc = gql `
  fragment PlaylistItemResults on YoutubePlaylistItemResults {
    count
    pageInfo {
      ...PageInfo
    }
    items {
      id
      snippet {
        ...PlaylistItemSnippet
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${PlaylistItemSnippetFragmentDoc}
`;
export const PlaylistFunctionFragmentDoc = gql `
  fragment PlaylistFunction on YoutubePlaylistFunctions {
    playlist {
      id
      snippet {
        ...PlaylistSnippet
      }
      playlistItems(paging: $paging) {
        ...PlaylistItemResults
      }
    }
  }
  ${PlaylistSnippetFragmentDoc}
  ${PlaylistItemResultsFragmentDoc}
`;
export const PlaylistResultsFragmentDoc = gql `
  fragment PlaylistResults on YoutubePlaylistResults {
    count
    pageInfo {
      ...PageInfo
    }
    items {
      id
      snippet {
        ...PlaylistSnippet
      }
      playlistItems(paging: $paging) {
        ...PlaylistItemResults
      }
    }
  }
  ${PageInfoFragmentDoc}
  ${PlaylistSnippetFragmentDoc}
  ${PlaylistItemResultsFragmentDoc}
`;
export const ChannelFunctionFragmentDoc = gql `
  fragment ChannelFunction on YoutubeChannelFunctions {
    channel {
      id
      snippet {
        title
        description
        customUrl
        publishedAt {
          timestampMs
          timestamp
          iso8601
        }
        thumbnails {
          ...ThumbnailMap
        }
      }
      playlists {
        ...PlaylistResults
      }
      uploadsPlaylist {
        id
        youtube {
          ...PlaylistFunction
        }
      }
    }
  }
  ${ThumbnailMapFragmentDoc}
  ${PlaylistResultsFragmentDoc}
  ${PlaylistFunctionFragmentDoc}
`;
export const YoutubeFragmentDoc = gql `
  fragment Youtube on SitesYoutubeBlock {
    playlist {
      id
      youtube {
        ...PlaylistFunction
      }
    }
    channel {
      id
      youtube {
        ...ChannelFunction
      }
    }
    default_video_id
  }
  ${PlaylistFunctionFragmentDoc}
  ${ChannelFunctionFragmentDoc}
`;
export const BlockFragmentDoc = gql `
  fragment Block on SitesPageBlock {
    id
    region
    type
    ordinal
    value
    tags
    schedule {
      begin
      end
    }
    ...Feed
    ...Item
    ...Podcasts
    ...Shows
    ...KeywordContest
    ...Youtube
  }
  ${FeedFragmentDoc}
  ${ItemFragmentDoc}
  ${PodcastsFragmentDoc}
  ${ShowsFragmentDoc}
  ${KeywordContestFragmentDoc}
  ${YoutubeFragmentDoc}
`;
export const PageFragmentDoc = gql `
  fragment Page on SitesPageRecord {
    _id
    name
    pageConfig
    displayName
    path
    primaryBlockId
    layoutId
    parentId
    tags {
      id
    }
    blocks {
      ...Block
    }
  }
  ${BlockFragmentDoc}
`;
export const SitemapContentItemFragmentDoc = gql `
  fragment SitemapContentItem on PubsubPublishRecord {
    slug
    pub_start
    summary {
      title
    }
    payload
    subscription {
      tags
    }
  }
`;
export const PreviousNextItemFragmentDoc = gql `
  fragment PreviousNextItem on PubsubPublishRecord {
    slug
    pub_start
    pub_until
    pub_changed
    summary {
      title
      image
    }
  }
`;
export const CoastSearchItemFragmentDoc = gql `
  fragment CoastSearchItem on PWSCoastSearchItem {
    ref_id
    slug
    type
    category
    pub_start {
      timestampMs
    }
    summary {
      title
      description
      image
    }
    source
    source_url
  }
`;
export const PwsSearchResponseFragmentDoc = gql `
  fragment PWSSearchResponse on PWSCoastSearchResponse {
    value {
      ... on PWSCoastSearchResponseMergedValue {
        items {
          ...CoastSearchItem
        }
      }
    }
    pageInfo {
      nextCursor
    }
  }
  ${CoastSearchItemFragmentDoc}
`;
export const CoastFeaturedItemFragmentDoc = gql `
  fragment CoastFeaturedItem on PWSCoastFeaturedItem {
    slug
    pub_start {
      timestampMs
    }
    content_type
    summary {
      image
      title
    }
  }
`;
export const TagSourceFragmentDoc = gql `
  fragment TagSource on TagSource {
    id
    display_name
    description
    source_name
    type
  }
`;
export const GetPodcastEpisodesDocument = gql `
  query GetPodcastEpisodes($id: Int!, $paging: AMPPageInput) {
    amp {
      podcast(id: $id) {
        ...Podcast
      }
    }
  }
  ${PodcastFragmentDoc}
`;
export const GetCurrentTrackDocument = gql `
  query GetCurrentTrack($slug: String!) {
    sites {
      find(type: SLUG, value: $slug) {
        stream {
          amp {
            currentTrack {
              ...TrackDetail
            }
          }
        }
      }
    }
  }
  ${TrackDetailFragmentDoc}
`;
export const GetTopSongsDocument = gql `
  query GetTopSongs($slug: String!, $paging: AMPPageInput) {
    sites {
      find(type: SLUG, value: $slug) {
        stream {
          amp {
            topTracks(paging: $paging) {
              ...TopTracks
            }
          }
        }
      }
    }
  }
  ${TopTracksFragmentDoc}
`;
export const GetCurrentlyPlayingSongsDocument = gql `
  query GetCurrentlyPlayingSongs($slug: String!, $paging: AMPPageInput) {
    sites {
      find(type: SLUG, value: $slug) {
        stream {
          amp {
            currentlyPlaying(paging: $paging) {
              ...CurrentlyPlaying
            }
          }
        }
      }
    }
  }
  ${CurrentlyPlayingFragmentDoc}
`;
export const GetContestsDocument = gql `
  query GetContests($accountId: String!) {
    aptivada(accountId: $accountId) {
      apps {
        ...AptivadaApp
      }
    }
  }
  ${AptivadaAppFragmentDoc}
`;
export const GetContestDocument = gql `
  query GetContest($accountId: String!, $appId: String!) {
    aptivada(accountId: $accountId) {
      app(appId: $appId) {
        ...AptivadaApp
      }
    }
  }
  ${AptivadaAppFragmentDoc}
`;
export const GetKeywordContestDocument = gql `
  query GetKeywordContest($accountId: String!, $appId: String!) {
    aptivada(accountId: $accountId) {
      keyword(appId: $appId) {
        ...AptivadaKeywordApp
      }
    }
  }
  ${AptivadaKeywordAppFragmentDoc}
`;
export const GetEventCategoriesDocument = gql `
  query GetEventCategories($slug: String!) {
    sites {
      find(type: SLUG, value: $slug) {
        eventCategories
      }
    }
  }
`;
export const GetEventsDocument = gql `
  query GetEvents($type: SITES_LOOKUP_BY!, $value: String!, $category: String, $limit: Int, $offset: Int) {
    sites {
      find(type: $type, value: $value) {
        events(category: $category, num: $limit, offset: $offset) {
          ...CalendarEvent
        }
      }
    }
  }
  ${CalendarEventFragmentDoc}
`;
export const GetOccurrenceDocument = gql `
  query GetOccurrence($occurrenceId: String) {
    calendar {
      occurrence(occurrenceId: $occurrenceId) {
        ...CalendarEvent
      }
    }
  }
  ${CalendarEventFragmentDoc}
`;
export const GetChartsForSitemapDocument = gql `
  query GetChartsForSitemap($brand: String!, $listsSize: Int!) {
    charts {
      charts {
        filter(filters: { brand: $brand }) {
          items {
            slug
            lists(filters: { size: $listsSize }) {
              items {
                slug
                published {
                  timestampMs
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetChartV2Document = gql `
  query GetChartV2(
    $slug: String!
    $listsSize: Int
    $listsStartDate: Float
    $listsEndDate: Float
    $listsCursor: String
    $includeDates: Boolean = false
    $includeLists: Boolean = false
  ) {
    charts {
      charts {
        bySlug(slug: $slug) {
          ...ChartV2
        }
      }
    }
  }
  ${ChartV2FragmentDoc}
`;
export const GetChartListsPartialsDocument = gql `
  query GetChartListsPartials($chartSlug: String, $size: Int, $startDate: Float, $endDate: Float, $cursor: String) {
    charts {
      lists {
        filter(
          chartSlug: $chartSlug
          filters: { size: $size, cursor: $cursor, startDate: $startDate, endDate: $endDate }
        ) {
          ...ChartListPartialResults
        }
      }
    }
  }
  ${ChartListPartialResultsFragmentDoc}
`;
export const GetChartListDocument = gql `
  query GetChartList($slug: String!) {
    charts {
      lists {
        bySlug(slug: $slug) {
          ...ChartsList
        }
      }
    }
  }
  ${ChartsListFragmentDoc}
`;
export const GetSiteByQueryDocument = gql `
  query GetSiteByQuery($type: SITES_LOOKUP_BY!, $value: String!, $lookup: String!) {
    sites {
      find(type: $type, value: $value) {
        ...SiteConfig
      }
    }
  }
  ${SiteConfigFragmentDoc}
`;
export const GetContactEmailsDocument = gql `
  query GetContactEmails($type: SITES_LOOKUP_BY!, $value: String!, $lookup: String!) {
    sites {
      find(type: $type, value: $value) {
        configByLookup(lookup: $lookup) {
          sections {
            ... on SitesTemplateInfernoSite {
              contact {
                contacts {
                  type
                  email
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetSiteChildrenDocument = gql `
  query GetSiteChildren($children: [SitesFindManyLookup!]!) {
    sites {
      findMany(lookups: $children) {
        ...SiteChildRef
      }
    }
  }
  ${SiteChildRefFragmentDoc}
`;
export const GetMicrositeByQueryDocument = gql `
  query GetMicrositeByQuery($slug: String!, $micrositeSlug: String!, $lookup: String!) {
    sites {
      find(type: SLUG, value: $slug) {
        inboundRef(by: EMBEDDED_IN, type: SLUG, value: $micrositeSlug) {
          _id
          slug
          ownBrand
          timeZone
          summary {
            name
          }
          status {
            hide {
              startDate
              endDate
              redirectTo
            }
            isHidden
            isActive
          }
          keys
          configByLookup(lookup: $lookup) {
            _id
            routes {
              name
              path
            }
            sections {
              ... on SitesTemplateInfernoMicrosite {
                general {
                  ...MicrositeGeneralConfig
                }
                navigation {
                  enable_nav_switch
                  menu {
                    id
                    type
                    label
                    target
                    ref
                    children {
                      id
                      type
                      label
                      target
                      ref
                    }
                  }
                }
                contact {
                  full_bio
                  phone_number
                  txt_number
                  email_address
                }
                social {
                  ...MicrositeSocialConfig
                }
              }
            }
          }
          inboundKeys(by: PRIMARY_PARENT_OF) {
            slug
            canonicalHostname
          }
        }
      }
    }
  }
  ${MicrositeGeneralConfigFragmentDoc}
  ${MicrositeSocialConfigFragmentDoc}
`;
export const GetSlugByBrandTagDocument = gql `
  query GetSlugByBrandTag($type: SITES_LOOKUP_BY!, $value: String!) {
    sites {
      find(type: $type, value: $value) {
        _id
        slug
      }
    }
  }
`;
export const GetNavigationMicrositesDocument = gql `
  query GetNavigationMicrosites($lookups: [SitesFindManyLookup!]!, $lookup: String!) {
    sites {
      findMany(lookups: $lookups) {
        ...NavigationMicrosite
      }
    }
  }
  ${NavigationMicrositeFragmentDoc}
`;
export const GetSlugFromHostnameDocument = gql `
  query GetSlugFromHostname($hostname: String!) {
    sites {
      find(type: HOSTNAME, value: $hostname) {
        slug
      }
    }
  }
`;
export const GetTimelineSitesDocument = gql `
  query GetTimelineSites($active: Boolean!, $take: Int!) {
    sites {
      filter(filter: { active: $active, hidden: false }, paging: { take: $take }) {
        results {
          slug
          ownBrand
          canonicalHostname
        }
      }
    }
  }
`;
export const GetHistoricalContentDocument = gql `
  query GetHistoricalContent($query: PubsubQueryInput!) {
    pubsub {
      query(type: "content", query: $query) {
        items {
          slug
          pub_start
        }
        page {
          nextToken
        }
      }
    }
  }
`;
export const GetOnAirNowDocument = gql `
  query GetOnAirNow($slug: String!, $currentDate: Float) {
    sites {
      find(type: SLUG, value: $slug) {
        onAirSchedule(currentDate: $currentDate) {
          ...OnAirSchedule
        }
      }
    }
  }
  ${OnAirScheduleFragmentDoc}
`;
export const GetOnAirNowByDayDocument = gql `
  query GetOnAirNowByDay($day: SITES_ONAIR_DAY!, $slug: String!, $currentDate: Float) {
    sites {
      find(type: SLUG, value: $slug) {
        timeZone
        onAirSchedule(currentDate: $currentDate) {
          ...OnAirSchedule
        }
        onAirScheduleForDay(day: $day) {
          schedule {
            ...OnAirShow
          }
        }
      }
    }
  }
  ${OnAirScheduleFragmentDoc}
  ${OnAirShowFragmentDoc}
`;
export const GetPageDocument = gql `
  query GetPage(
    $name: String!
    $slug: String!
    $lookup: String!
    $context: JSON!
    $scopes: [String!]
    $from: String
    $paging: PageTokenInput
  ) {
    sites {
      find(type: SLUG, value: $slug) {
        _id
        configByLookup(lookup: $lookup) {
          _id
          page(name: $name) {
            ...Page
          }
        }
      }
    }
  }
  ${PageFragmentDoc}
`;
export const GetSitePagesDocument = gql `
  query GetSitePages($type: SITES_LOOKUP_BY!, $value: String!, $lookup: String!) {
    sites {
      find(type: $type, value: $value) {
        _id
        configByLookup(lookup: $lookup) {
          _id
          pages {
            _id
            name
            displayName
            path
            pageConfig
          }
        }
      }
    }
  }
`;
export const GetFeedContentDocument = gql `
  query GetFeedContent(
    $type: SITES_LOOKUP_BY!
    $value: String!
    $lookup: String!
    $usage: String!
    $context: JSON
    $size: Int
  ) {
    sites {
      find(type: $type, value: $value) {
        _id
        configByLookup(lookup: $lookup) {
          _id
          feed(params: { id: $usage, context: $context, size: $size }) {
            results {
              ...FeedResult
            }
          }
        }
      }
    }
  }
  ${FeedResultFragmentDoc}
`;
export const GetDatasourceBySlugDocument = gql `
  query GetDatasourceBySlug($slug: String!, $lookup: String!, $resume: SitesFeedResumeInput!) {
    sites {
      find(type: SLUG, value: $slug) {
        _id
        configByLookup(lookup: $lookup) {
          _id
          feed(params: $resume) {
            ...FeedResponse
          }
        }
      }
    }
  }
  ${FeedResponseFragmentDoc}
`;
export const GetSitemapContentDocument = gql `
  query GetSitemapContent($query: PubsubQueryInput!) {
    pubsub {
      query(type: "content", query: $query) {
        items {
          ...SitemapContentItem
        }
      }
    }
  }
  ${SitemapContentItemFragmentDoc}
`;
export const GetCoastPreviousNextFeedDocument = gql `
  query GetCoastPreviousNextFeed($query: PubsubQueryInput!, $type: String!) {
    pubsub {
      query(type: $type, query: $query) {
        items {
          ...PreviousNextItem
        }
      }
    }
  }
  ${PreviousNextItemFragmentDoc}
`;
export const GetCoastContentItemDocument = gql `
  query GetCoastContentItem($type: String!, $slug: String!) {
    pubsub {
      get(type: $type, select: { slug: $slug }) {
        ref_id
        type
        payload
        slug
        summary {
          image
          title
          description
          author
        }
        pub_start
        pub_until
        pub_changed
        subscription {
          tags
        }
      }
    }
  }
`;
export const GetPwsSearchResultsDocument = gql `
  query GetPWSSearchResults(
    $keyword: String!
    $includeArticles: Boolean
    $includeGuests: Boolean
    $includeShows: Boolean
    $cursor: String
    $offset: Int
    $limit: Int
  ) {
    pws {
      coastAppContent {
        search(
          term: $keyword
          platform: DESKTOP
          doMerge: true
          includeArticles: $includeArticles
          includeGuests: $includeGuests
          includeShows: $includeShows
          cursor: $cursor
          offset: $offset
          limit: $limit
        ) {
          ...PWSSearchResponse
        }
      }
    }
  }
  ${PwsSearchResponseFragmentDoc}
`;
export const CoastFeaturedDocument = gql `
  query CoastFeatured($sections: Int = 3, $shows: Int = 2, $photos: Int = 1, $articles: Int = 5) {
    pws {
      coastAppContent {
        featured(platform: DESKTOP, sections: $sections, shows: $shows, photos: $photos, articles: $articles) {
          ... on PWSCoastFeaturedDesktopPlatform {
            value {
              ...CoastFeaturedItem
            }
          }
        }
      }
    }
  }
  ${CoastFeaturedItemFragmentDoc}
`;
export const GetTopicDocument = gql `
  query GetTopic($topic: String!, $locale: String!) {
    taxonomy {
      topic(topic: $topic, locale: $locale) {
        name
        source {
          ...TagSource
        }
        displayName
      }
    }
  }
  ${TagSourceFragmentDoc}
`;
export const GetTagDocument = gql `
  query GetTag($tag: String!, $locale: String!) {
    taxonomy {
      tag(tag: $tag, locale: $locale) {
        name
        memberName
        displayName
        ns
        source {
          ...TagSource
        }
      }
    }
  }
  ${TagSourceFragmentDoc}
`;
export function getSdk(factory) {
    return {
        GetPodcastEpisodes: factory("GetPodcastEpisodes", "Query", print(GetPodcastEpisodesDocument)),
        GetCurrentTrack: factory("GetCurrentTrack", "Query", print(GetCurrentTrackDocument)),
        GetTopSongs: factory("GetTopSongs", "Query", print(GetTopSongsDocument)),
        GetCurrentlyPlayingSongs: factory("GetCurrentlyPlayingSongs", "Query", print(GetCurrentlyPlayingSongsDocument)),
        GetContests: factory("GetContests", "Query", print(GetContestsDocument)),
        GetContest: factory("GetContest", "Query", print(GetContestDocument)),
        GetKeywordContest: factory("GetKeywordContest", "Query", print(GetKeywordContestDocument)),
        GetEventCategories: factory("GetEventCategories", "Query", print(GetEventCategoriesDocument)),
        GetEvents: factory("GetEvents", "Query", print(GetEventsDocument)),
        GetOccurrence: factory("GetOccurrence", "Query", print(GetOccurrenceDocument)),
        GetChartsForSitemap: factory("GetChartsForSitemap", "Query", print(GetChartsForSitemapDocument)),
        GetChartV2: factory("GetChartV2", "Query", print(GetChartV2Document)),
        GetChartListsPartials: factory("GetChartListsPartials", "Query", print(GetChartListsPartialsDocument)),
        GetChartList: factory("GetChartList", "Query", print(GetChartListDocument)),
        GetSiteByQuery: factory("GetSiteByQuery", "Query", print(GetSiteByQueryDocument)),
        GetContactEmails: factory("GetContactEmails", "Query", print(GetContactEmailsDocument)),
        GetSiteChildren: factory("GetSiteChildren", "Query", print(GetSiteChildrenDocument)),
        GetMicrositeByQuery: factory("GetMicrositeByQuery", "Query", print(GetMicrositeByQueryDocument)),
        GetSlugByBrandTag: factory("GetSlugByBrandTag", "Query", print(GetSlugByBrandTagDocument)),
        GetNavigationMicrosites: factory("GetNavigationMicrosites", "Query", print(GetNavigationMicrositesDocument)),
        GetSlugFromHostname: factory("GetSlugFromHostname", "Query", print(GetSlugFromHostnameDocument)),
        GetTimelineSites: factory("GetTimelineSites", "Query", print(GetTimelineSitesDocument)),
        GetHistoricalContent: factory("GetHistoricalContent", "Query", print(GetHistoricalContentDocument)),
        GetOnAirNow: factory("GetOnAirNow", "Query", print(GetOnAirNowDocument)),
        GetOnAirNowByDay: factory("GetOnAirNowByDay", "Query", print(GetOnAirNowByDayDocument)),
        GetPage: factory("GetPage", "Query", print(GetPageDocument)),
        GetSitePages: factory("GetSitePages", "Query", print(GetSitePagesDocument)),
        GetFeedContent: factory("GetFeedContent", "Query", print(GetFeedContentDocument)),
        GetDatasourceBySlug: factory("GetDatasourceBySlug", "Query", print(GetDatasourceBySlugDocument)),
        GetSitemapContent: factory("GetSitemapContent", "Query", print(GetSitemapContentDocument)),
        GetCoastPreviousNextFeed: factory("GetCoastPreviousNextFeed", "Query", print(GetCoastPreviousNextFeedDocument)),
        GetCoastContentItem: factory("GetCoastContentItem", "Query", print(GetCoastContentItemDocument)),
        GetPWSSearchResults: factory("GetPWSSearchResults", "Query", print(GetPwsSearchResultsDocument)),
        CoastFeatured: factory("CoastFeatured", "Query", print(CoastFeaturedDocument)),
        GetTopic: factory("GetTopic", "Query", print(GetTopicDocument)),
        GetTag: factory("GetTag", "Query", print(GetTagDocument)),
    };
}
//# sourceMappingURL=webapi.g.js.map